import React, { Key } from 'react';
import {
  ColumnFilterItem,
  FilterDropdownProps,
} from 'antd/lib/table/interface';
import { Spacing } from 'works/legacy/lib/style-helper';
import { MultipleSelectSearch } from '@common/components';

export function MultiSelectTableFilter({
  selectedKeys,
  setSelectedKeys,
  confirm,
  filters,
}: FilterDropdownProps) {
  return (
    <section style={{ padding: `${Spacing.baseSpacing / 2}px` }}>
      <MultipleSelectSearch
        options={Array.isArray(filters) ? filters?.map(filterToOption) : []}
        value={selectedKeys}
        onSearch={(values: Key[]) => {
          values ? setSelectedKeys(values) : setSelectedKeys([]);
          confirm();
        }}
      />
    </section>
  );
}

function filterToOption(filter: ColumnFilterItem) {
  return {
    label: filter.text,
    value: filter.value as number | string,
  };
}
